<template>
  <div :class="['map-pin-container', hasIcon ? 'map-pin-withicon' : '', hasLabel ? 'map-pin-withlabel' : '']" ref="marker">
    <i class="fas fa-caret-down map-pin-arrow" />
    <div class="map-pin-body">
      <div class="map-pin-icon" v-if="hasIcon">
        <slot name="icon" />
      </div>
      <div class="map-pin-label" v-if="hasLabel">
        <slot name="label" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.map-pin-container {
  position: relative;
  box-shadow: 4px 4px 8px rgba(0,0,0,0.33);
  border-collapse: collapse;
  border-radius: 12px;
}

.map-pin-body {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  height: 24px;
  min-width: 24px;
  max-width: 200px;
  font-weight: 400;
  font-size: 11px;
  margin-bottom: 12px;
  text-align: center;
}
.map-pin-withlabel .map-pin-body {
  min-width: 110px;
}

.map-pin-arrow {
  position: absolute;
  bottom: -20px;
  left: calc(50% - 12px);
  color: #ffffff;
  font-size: 36px;
}
.map-pin-container:not(.map-pin-withlabel) .map-pin-arrow {
  bottom: -12px;
  left: calc(50% - 8px);
  font-size: 24px;
}

.map-pin-label {
  line-height: 24px;
  vertical-align: middle;
  padding: 0px 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 500;
  margin-left: 24px;
}
.map-pin-container:not(.map-pin-withicon) .map-pin-label {
  margin-left: 0px;
}
.map-pin-icon {
  position: absolute;
  left: 2px;
  top: 2px;
  width: 20px;
  height: 20px;
}
</style>

<script>
export default {
  name: 'MapPin',
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    hasLabel: Boolean,
    hasIcon: Boolean,
    mapState: Object
  },
  data() {
    return {
      mapMarker: null,
      clickListener: null
    }
  },
  computed: {
  },
  watch: {
    position: function() {
      if(this.mapMarker)
        this.mapMarker.position = { lng: this.position.lng, lat: this.position.lat }
    }
  },
  mounted() {
    var markerOptions = {
      position: { lng: this.position.lng, lat: this.position.lat },
      zIndex: 150000,
      map: this.map
    }

    markerOptions.content = this.$refs.marker
    this.mapMarker = new this.google.maps.marker.AdvancedMarkerElement(markerOptions)

    this.clickListener = this.mapMarker.addListener("click", (evt) => {
      this.$emit('click', evt)
    })
  },
  beforeDestroy() {
    if(this.clickListener)
      this.clickListener.remove()
    if(this.mapMarker)
      this.mapMarker.setMap(null)
  }
}
</script>